module.exports = __webpack_public_path__ + "img/help_dataset_estimate2.dea73068.png";